var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1062 31C23.4715 30.9487 23.8419 30.9076 24.2021 30.8357C26.8555 30.322 28.9356 28.9247 30.4373 26.6593C31.4774 25.0874 32.005 23.3357 32 21.4401C31.9898 18.6302 30.9701 16.2415 28.9458 14.3048C28.1847 13.5754 27.3121 13.0103 26.3583 12.5737C25.9169 12.3733 25.4552 12.5069 25.2219 12.8922C24.9936 13.2723 25.0798 13.7655 25.4299 14.0326C25.5263 14.1045 25.6379 14.161 25.7444 14.2124C27.6064 15.1062 28.9407 16.5137 29.7169 18.4453C30.2496 19.7706 30.4018 21.1473 30.1837 22.5651C29.9249 24.2398 29.2096 25.6781 28.0427 26.8853C27.0026 27.959 25.7546 28.6781 24.3036 29.0172C22.2793 29.4949 20.3615 29.2072 18.5706 28.1439C16.8608 27.1319 15.694 25.6576 15.1004 23.7518C14.4155 21.5583 14.6438 19.4316 15.7751 17.4281C16.592 15.9795 17.769 14.911 19.2606 14.2124C19.5244 14.0891 19.7527 13.9298 19.8592 13.637C19.9759 13.3083 19.8846 12.9333 19.6259 12.7021C19.3367 12.4453 19.0018 12.3887 18.667 12.5685C18.0734 12.887 17.4595 13.1901 16.9217 13.5908C14.9685 15.0343 13.7153 16.9658 13.213 19.3648C12.1984 24.2449 14.9329 29.0018 19.6208 30.5429C20.3108 30.7689 21.016 30.9076 21.7415 30.959C21.7922 30.9641 21.843 30.9846 21.8937 30.9949C22.2945 31 22.7004 31 23.1062 31Z",
    fill: "#6160DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6395 14.8031C21.6395 16.0925 21.6395 17.387 21.6395 18.6764C21.6395 19.2106 21.9439 19.5651 22.4309 19.6165C22.8723 19.6627 23.2934 19.3237 23.3492 18.8767C23.3594 18.7945 23.3594 18.7124 23.3594 18.6302C23.3594 16.0822 23.3594 13.5343 23.3594 10.9863C23.3594 10.4983 23.1514 10.1695 22.7658 10.0463C22.228 9.86646 21.6648 10.2517 21.6446 10.8271C21.6243 11.4949 21.6395 12.1678 21.6344 12.8356C21.6395 13.488 21.6395 14.1456 21.6395 14.8031Z",
    fill: "#6160DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.315d2e0776e9e7753a6fe48cccc3739b.svg";
export { ForwardRef as ReactComponent };